<template>
  <el-row>
    <b v-if="row.name" @click="$emit('clickName', row)">{{ row.name }}（{{ (row.storehouseCode || row.execDeptCode) | dictText("Storehouse") }}）</b>

    <el-row>
      <el-row>
        <span v-for="v in items" :key="v.id" type="info" class="right-pad bottom-pad" size="small" hit>
          {{ v.name }}
          <b class="danger">{{ v.quantity }}</b>
          {{ v.detailObj.unit }}
          <b v-if="v.usage" class="danger">{{ v.usage | dictText("HerbalSpecialUsage") }}</b>
        </span>
      </el-row>
      <el-tag v-if="row.id" type="info" hit style="border-left: #E6A23C 40px solid" class="top-pad">
        <span style="margin: 0 10px 0 -40px; color: white">草药</span>
        <span class="left-pad">
          <b class="danger">{{ row.makeMethod | dictText("HerbalMakeMethod") }}</b>
        </span>
        <span v-if="row.dosagePerTime" class="left-pad">
          <b class="danger">{{ row.dosagePerTime }}ml</b>
        </span>
        <span class="left-pad">
          <b class="danger">{{ row.usage | dictText("HerbalUsage") }}</b>
        </span>
        <span class="left-pad">
          <b class="danger">{{ row.frequency | dictText("HerbalFrequency") }}</b>
        </span>
        <span class="left-pad" v-if="row.ifMake">
          <el-tag type="danger" size="mini" effect="dark" hit>代煎</el-tag>
        </span>
      </el-tag>
    </el-row>
  </el-row>
</template>
<script>
  export default {
    props: {
      row: Object,
    },
    computed: {
      items() {
        this.row.items.forEach((item) => {
          try {
            item.detailObj = JSON.parse(item.detail);
          } catch (e) {
            item.detailObj = {};
          }
        });
        return this.row.items;
      },
    },
  };
</script>
